import React from "react";
import { Container } from "react-bootstrap";

import "./maincontent.css";

function MainContent() {
  return (
    <div className="full-section">
      <video
        className="back__video"
        controls={false}
        autoPlay
        muted
        loop="infinite"
      >
        <source
          src={`/assets/hero-background.mp4`}
          type="video/mp4"
        />
      </video>
      <Container>
        <div className="d-flex justify-content-between align-items-center main-container">
          <div className="img__div">
            <img
              className="side-image"
              src={`/assets/4_DSCF6793.jpeg`}
              alt="Glen Callahan coaching session"
            />
          </div>
          <div className="hero-content">
            <h1>Feeling stuck? You don't have to figure it out alone.</h1>
            <br />
            <p>
              Whether you're navigating a major life change, struggling with
              stress, or searching for direction and purpose — these challenges
              don't resolve themselves. But with the right support, you can
              move through them with clarity and confidence.
            </p>
            <p>
              I'm Glen Callahan, a developmental coach based in Tauranga.
              I hold an ICF-accredited coaching certificate, a diploma in
              Vedanta philosophy from eight years of study in India, and
              over 18 years of experience in personal development — both
              practising it and guiding others through it.
            </p>
            <p>
              My approach combines evidence-based coaching with the timeless
              self-development wisdom of India. It's practical, grounded, and
              built around you.
            </p>
            <a
              href="https://calendly.com/glen-coaching/strategy"
              target="_blank"
              rel="noreferrer"
            >
              <button>Book a Free Strategy Session</button>
            </a>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default MainContent;
